// argument shall be a number separated into an array: [1,2,3,4]
// https://en.wikipedia.org/wiki/Luhn_algorithm
// The formula verifies a number against its included check digit, which is usually appended
// to a partial account number to generate the full account number. This number must pass the following test:
// 1.From the rightmost digit, which is the check digit, and moving left, double the value of
// every second digit. If the result of this doubling operation is greater than 9 (e.g., 8 × 2 = 16), then
// either...
// a) add the digits of the product (e.g., 16: 1 + 6 = 7, 18: 1 + 8 = 9)
// or alternatively...
// b) subtract 9 from the product (e.g., 16: 16 - 9 = 7, 18: 18 - 9 = 9).
// 2. Take the sum of all the digits.
// 3. If the total modulo 10 is equal to 0 (if the total ends in zero) then the number is valid according to the Luhn formula; else it is not valid.
function splitIntoArrOfDigitsBelowTen(t) {
	// convert a number to an array with each number
	// input:1234123412341234
	// output:[1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4]
	const str = t && t.toString ? t.toString() : null;
	const spl = str ? str.split('') : null;
	const arr = [];
	const L = spl && spl.length ? spl.length : 0;
	for (let i = 0; i < L; i += 1) {
		arr[i] = Number(spl[i]) || 0;
	}
	return arr;
}

// function luhnCheck(arr = []) {
function luhnCheck(t = []) {
	const okInput = Array.isArray(t) || typeof t === 'string' || typeof t === 'number';
	if (!okInput) {
		throw new Error('luhn-check: only strings, numbers or arrays accepted', t);
	}
	const arr = typeof t === 'string' || typeof t === 'number' ? splitIntoArrOfDigitsBelowTen(t) : t;
	let L = arr.length;
	let isSecond = true;
	let cDigit = 0;
	let cSum = 0;
	while (L) {
		L -= 1;
		isSecond = !isSecond;
		cDigit = arr[L];
		if (isSecond) {
			cDigit *= 2;
			cDigit = cDigit > 9 ? cDigit - 9 : cDigit;
		}
		cSum += cDigit;
	}
	return cSum && cSum % 10 === 0;
}
export { luhnCheck, splitIntoArrOfDigitsBelowTen };
